import { ReactNode, useId } from "react";
import { useTranslation } from "react-i18next";
import VisuallyHidden from "components/common/VisuallyHidden";

type Props = {
    // id of the question title (or sub-title) naming the group
    titleId: string;
    maxNumberOfAnswers?: number;
    className?: string;
    children: ReactNode;
};

// Groups the proposals of a question so screen readers announce the question
// and the number of possible answers when entering the group
const ProposalsGroup = ({
    titleId,
    maxNumberOfAnswers,
    className,
    children,
}: Props) => {
    const { t } = useTranslation();
    const hintId = useId();

    let hint: string | null = null;
    if (1 === maxNumberOfAnswers) {
        hint = t("answersAllowed.one");
    } else if (maxNumberOfAnswers) {
        hint = t("answersAllowed.upTo", { count: maxNumberOfAnswers });
    }

    return (
        <div
            role="group"
            aria-labelledby={titleId}
            aria-describedby={hint ? hintId : undefined}
            className={className}
        >
            {hint && <VisuallyHidden id={hintId}>{hint}</VisuallyHidden>}
            {children}
        </div>
    );
};

export default ProposalsGroup;
